export default __webpack_public_path__ + "static/media/facebook.742b3843.svg";